import api from './apiService'; // Authenticated Axios instance (attaches the Bearer token)

const BASE = 'notifications';

export const notificationService = {
  // Dropdown metadata: available events (with placeholders) + roles.
  getMetadata: async () => {
    const response = await api.get(`${BASE}/metadata`);
    return response.data;
  },

  // Master on/off switch for a lab.
  getSetting: async (laboratoryId) => {
    const response = await api.get(`${BASE}/settings/${laboratoryId}`);
    return response.data;
  },
  updateSetting: async (laboratoryId, isEnabled) => {
    const response = await api.put(`${BASE}/settings/${laboratoryId}`, { isEnabled });
    return response.data;
  },

  // Configured rules.
  getConfigs: async (laboratoryId) => {
    const response = await api.get(`${BASE}/config/${laboratoryId}`);
    return response.data;
  },
  addConfig: async (config) => {
    const response = await api.post(`${BASE}/config`, config);
    return response.data;
  },
  updateConfig: async (id, config) => {
    const response = await api.put(`${BASE}/config/${id}`, config);
    return response.data;
  },
  deleteConfig: async (id) => {
    const response = await api.delete(`${BASE}/config/${id}`);
    return response.data;
  },

  // Per-user notification feed.
  getForUser: async (laboratoryId, userId, { unreadOnly = false, pageNumber = 1, pageSize = 20 } = {}) => {
    const response = await api.get(BASE, {
      params: { laboratoryId, userId, unreadOnly, pageNumber, pageSize }
    });
    return response.data;
  },
  getUnreadCount: async (laboratoryId, userId) => {
    const response = await api.get(`${BASE}/unread-count`, {
      params: { laboratoryId, userId }
    });
    return response.data.unreadCount;
  },
  markAsRead: async (id, userId) => {
    const response = await api.put(`${BASE}/${id}/read`, null, { params: { userId } });
    return response.data;
  },
  markAllAsRead: async (laboratoryId, userId) => {
    const response = await api.put(`${BASE}/read-all`, null, { params: { laboratoryId, userId } });
    return response.data;
  }
};
